import { ShipperSlider } from '@/components/ShipperSlider'
import { ScheduledReportsPanel } from '@/features/scheduled-reports/ScheduledReportsPanel'

type ScheduledReportsControlsProps = {
  isOpen: boolean
  onClose: () => void
}

export const ScheduledReportsControls = ({
  isOpen,
  onClose,
}: ScheduledReportsControlsProps) => {
  return (
    <ShipperSlider width="54em" isOpen={isOpen} onClose={onClose}>
      {isOpen && <ScheduledReportsPanel onClose={onClose} />}
    </ShipperSlider>
  )
}
